import React from 'react';
import { bool, func, object, string } from 'prop-types';
import { Button } from '../../../../../ps-aspect-design';
import CellIndicator from 'ps-components/LoadingIndicator/CellIndicator/CellIndicator';
import './GeoLandingPageHeader.scss';

const DOWNLOAD_LINK_TEXT = 'Download';
const FEATURE_NAME = 'Explore Geo Differential';
const RETURN_TO_PULSE_TEXT = 'Return to Differentials Engine home page';
const SETTINGS_LINK_TEXT = 'Data Settings';
const DATA_METHODOLOGY_LINK_TEXT = 'Data Methodology';

GeoLandingPageHeader.propTypes = {
  csvLoading: bool,
  handleCSVDownload: func,
  history: object,
  isCompanyLocationTabEnabled: bool,
  landingPageURL: string,
  selectedApplyStrategy: string,
  setShowDataMethodologySlideout: func,
  setShowSettingsSlideout: func,
  showApplyGeo: bool,
  showExploreGeo: bool
};

function GeoLandingPageHeader(props) {
  const {
    csvLoading,
    handleCSVDownload,
    history,
    isCompanyLocationTabEnabled,
    landingPageURL,
    selectedApplyStrategy,
    setShowDataMethodologySlideout,
    setShowSettingsSlideout,
    showApplyGeo,
    showExploreGeo
  } = props;

  function renderAction(icon, text, onClick) {
    const variant = !!icon ? 'icon-link' : 'link';
    return (
      <Button
        className="action-link"
        data-testid={`${text}-link`}
        icon={icon}
        onClick={() => onClick()}
        variant={variant}
      >
        {text}
      </Button>
    );
  }

  function renderActionRow() {
    return (
      <>
        <div className="header-row">
          {renderAction('Reply', RETURN_TO_PULSE_TEXT, returnToLandingPage)}
          {renderAction(null, DATA_METHODOLOGY_LINK_TEXT, () => setShowDataMethodologySlideout(true))}
        </div>
        {(showExploreGeo || (selectedApplyStrategy && showApplyGeo)) && (
          <div className="header-row header-actions">
            {renderAction('Cog', SETTINGS_LINK_TEXT, () => setShowSettingsSlideout(true))}
            {csvLoading ? (
              <CellIndicator iconClass="icon-animate-spin icon-spin cell-indicator" />
            ) : (
              renderAction('Download', DOWNLOAD_LINK_TEXT, handleCSVDownload)
            )}
          </div>
        )}
      </>
    );
  }

  function renderTitleRow() {
    return (
      <div className="header-row title-row">
        <h2 className="left-panel">{FEATURE_NAME}</h2>
      </div>
    );
  }

  function returnToLandingPage() {
    history.push(landingPageURL);
  }

  return (
    <div className="feature-content__header">
      {renderActionRow()}
      {!isCompanyLocationTabEnabled && renderTitleRow()}
    </div>
  );
}

export default GeoLandingPageHeader;
